import { useAtomValue } from 'jotai'
import { isAbortedAtom, isAbortingAtom } from '@/src/stores/route-machine/atoms'
import { BasicStepRow } from './basic-step-row'

export const RecoverRow = () => {
  const isAborting = useAtomValue(isAbortingAtom)
  const isAborted = useAtomValue(isAbortedAtom)

  if (!isAborting && !isAborted) {
    return null
  }

  return (
    <BasicStepRow
      title={isAborting ? 'Recovering funds' : 'Funds recovered'}
      isActive={isAborting}
      isLoading={isAborting}
      isSuccess={isAborted}
      isError={false}
    />
  )
}
